import { createRouter, createWebHistory } from 'vue-router'
import MitiServicesView from '../views/MitiServicesView.vue'

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: MitiServicesView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
